import React from 'react';
import { Link } from 'react-router-dom';
import './Css/Banner.css';

function Banner({
  pageName,
  pageLink,
  subtitle,
  eyebrow = 'Innovative Horizons',
  image
}) {
  const backgroundStyle = image
    ? { backgroundImage: `url(${image})` }
    : {};

  return (
    <section className="banner-hero" style={backgroundStyle}>
      <div className="banner-hero-overlay" />

      <div className="container banner-hero-inner">
        <div className="banner-copy">
          <div className="banner-eyebrow">{eyebrow}</div>

          <h1 className="banner-title">{pageName}</h1>

          {subtitle ? <p className="banner-subtitle">{subtitle}</p> : null}

          <div className="banner-breadcrumb">
            <Link to="/">Home</Link>
            <span>/</span>
            <Link to={pageLink}>{pageName}</Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Banner;